import {
  ContactsContainerStyled,
  ContactItemStyled,
  PartnersGridStyled,
  PartnerStyled,
  PartnerLogoStyled
} from './styles'

export const ContactsGrid = ({ contacts }) => (
  <ContactsContainerStyled>
    {contacts &&
      contacts.map((contact, index) => (
        <ContactItemStyled key={contact.id} index={index}>
          <img src={contact.photo} className="contact__photo" alt={contact.name} />

          <div>
            <p className="contact__name">{contact.name}</p>
            <p className="contact__position">{contact.description}</p>
            <a href={`mailto:${contact.email}`} target="_blank" rel="noopener noreferrer">
              {contact.email}
            </a>
            {contact.tel && (
              <a href={`tel:${contact.tel}`} target="_blank" rel="noopener noreferrer">
                {contact.tel}
              </a>
            )}
          </div>
        </ContactItemStyled>
      ))}
  </ContactsContainerStyled>
)

export const PartnersGrid = ({ name, partners, index }) => (
  <>
    {partners?.length !== 0 && (
      <PartnersGridStyled>
        <p className="name">{name}</p>
        <div className="grid">
          {partners.map(partner => (
            <PartnerStyled key={partner.id} index={index}>
              <a href={partner.site} target="_blank" rel="noopener noreferrer" title={partner.name}>
                <PartnerLogoStyled className="logo" logoUrl={partner.photo} />
              </a>
            </PartnerStyled>
          ))}
        </div>
      </PartnersGridStyled>
    )}
  </>
)
